<template>
  <div class="relative">
    <div v-if="loading" class="absolute min-h-screen w-full flex items-center justify-center z-50">
      <div  class="absolute bg-black inset-0 opacity-75">
      </div>
      <div class="h-12 w-12 text-white">
        <m-loader />
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'm-page-loader',
  computed: {
    loading() {
      return this.$store.getters['layout/isLoading'];
    },
  },
};
</script>
